import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        const response = await authAPI.exchangeSession(sessionId);
        
        // Store JWT token if provided (for consistent auth flow)
        if (response.data.token) {
          localStorage.setItem('token', response.data.token);
        }
        
        setUserData(response.data);
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { replace: true, state: { user: response.data } });
      } catch (error) {
        console.error('Session exchange failed:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUserData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ags-bg">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-ags-blue mx-auto mb-4" />
        <p className="text-ags-text-secondary">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
